export default {
  init() {
    // JavaScript to be fired on all pages

    const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'))
    const backLink = `<li class="nav-item">
      <a class="nav-link nav-back-link" href="javascript:;">
        Terug
      </a>
    </li>`

    navExpand.forEach(item => {
      item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', backLink)
      item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'))
      item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'))
    })

    if ($('#top-menu').length) {
      var menuscrollTrigger = 250, // px
      
      hideShowMenu = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > menuscrollTrigger) {
              $('#top-menu').addClass('hide');
              $('.header__logo').addClass('small');
              // $('.site-header').addClass('collapsed');  
          } else {
              $('#top-menu').removeClass('hide');
              $('.header__logo').removeClass('small');
              // $('.site-header').removeClass('collapsed');
          }
      };
      
      $(window).on('scroll', function () {
          hideShowMenu();
      });
    }

    // ---------------------------------------
    // not-so-important stuff starts here

    const ham = document.getElementById('ham')
    ham.addEventListener('click', function() {
      // 1. Toggle class in de body naar "nav is toggled"
      document.body.classList.toggle('nav-is-toggled');

      // 2. kijk of de toggle aan of uit staat:
      var navToggle = document.querySelector('body');
      // zet de aria-expanded op true/false om accessibility redenen
      if(navToggle.classList.contains('nav-is-toggled')) {
        this.setAttribute('aria-expanded', true);
      } else {
        this.setAttribute('aria-expanded', false);
      }
    })

    $(function () {
      $('[data-toggle="popover"]').popover().click(function( event ) {
        event.preventDefault();

        if (this.firstElementChild.alt == 'toon korte samenvatting') {
          this.firstElementChild.setAttribute('alt','sluit korte samenvatting');
        } else {
          this.firstElementChild.setAttribute('alt','toon korte samenvatting');
        }
      });
    })

    $('.socials a').click(function() {
      event.preventDefault();

      var href = $(this).attr('href');
      var title = $(this).attr('title');
      window.open(href,title,'scrollbars=yes,width=650,height=500');
       // alert(this);
    });

    $('.search_icon').click(function( event ) {
      event.preventDefault();
      
      $( '#search' ).addClass( 'active' );
      $ ('#search').attr('aria-expanded', true)
      $( '.search-field' ).focus();

    });

    $('#close').click(function() {
      $( '#search' ).removeClass( 'active' );
      $ ('#search').attr('aria-expanded', false)
    });

    $(document).on('keyup', function(event) {
      var search = document.getElementById('search');

      if(event.key == 'Escape' && search.classList.contains('active')) {
        search.classList.remove('active');
      }
    });
 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


export function setOffsetHeight() {

  //document query by id
  var header = document.getElementById('header');
  if (!header) {return;}

  //Scroll positie
  let navigationHeight = header.offsetHeight;
  let scrollpos = window.scrollY;

  window.addEventListener('load', () => {
    
    navigationHeight = header.offsetHeight;
    // console.log(navigationHeight);
    document.documentElement.style.setProperty('--scroll-padding', navigationHeight +'px');

  });

  // update on scroll:
  window.addEventListener('scroll', function() { 

    scrollpos = window.scrollY;
    //add or remove class
    if (scrollpos >= 200 ) { 
      header.classList.add('show');
    }
    else { 
      header.classList.remove('show');
    }
  })

  return navigationHeight;
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js